import { Button } from '@neo/index'
import { cn } from '@neo/lib/utils'
import { MessageCircleDashed, Trash } from 'lucide-react'
import { useFlowStore } from '../store'
import { SYSTEM_PROMPT_NODE_ID } from '../types'

export const SystemPromptNode: React.FC<{ className?: string }> = ({ className }) => {
  const selectedNodeID = useFlowStore((state) => state.selectedNodeID)
  const selectNode = useFlowStore((state) => state.selectNode)
  const isSelected = selectedNodeID === SYSTEM_PROMPT_NODE_ID
  const systemPrompt = useFlowStore((state) => state.systemPrompt)
  const setSystemPrompt = useFlowStore((state) => state.setSystemPrompt)
  const isEditing = useFlowStore((state) => state.isEditing)

  if (!systemPrompt) return null

  const handleNodeClick = () => {
    selectNode(SYSTEM_PROMPT_NODE_ID)
  }

  return (
    <div
      data-testid="system-prompt-node"
      className={cn('absolute top-4 left-4 z-10 transition-all duration-200 ease-out', className)}
      style={{ pointerEvents: 'auto' }}
      id="system-prompt-node"
    >
      <div
        className={cn(
          'flow-node group relative rounded-2xl transition-colors p-[1.2px] node-hover-gradient cursor-pointer',
          isSelected && 'selected',
        )}
        onClick={handleNodeClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            handleNodeClick()
          }
        }}
      >
        <div
          className={cn(
            'relative flex flex-col gap-1 w-[236px] bg-background z-10 transition-colors border border-st2 rounded-2xl hover:border-transparent',
            isSelected && 'border-transparent',
          )}
        >
          <div className={cn('flex flex-col gap-1 w-full bg-background rounded-2xl')}>
            <div className="min-h-8 p-3 rounded-xl text-s-500">
              <div className="flex items-center gap-2">
                <div className="flex items-center gap-2 bg-bg2 pr-3 rounded-md overflow-hidden">
                  <div className="rounded p-1.5 bg-flow-functions_bg text-flow-functions">
                    <MessageCircleDashed className="h-4 w-4" />
                  </div>
                  <span className="font-inter text-p-500">Global Prompt</span>
                </div>
                <div className="ml-auto nodrag group">
                  <Button
                    variant="ghost"
                    className={cn(
                      'hidden justify-center items-center',
                      isEditing && 'group-hover:flex',
                    )}
                    size="iconXs"
                    onClick={(e) => {
                      e.stopPropagation()
                      e.preventDefault()
                      setSystemPrompt(null)
                    }}
                    data-testid="button-delete-system-prompt"
                  >
                    <Trash size={16} className="text-destructive" />
                  </Button>
                </div>
              </div>
              <div className="font-inter text-s-400 text-secondary mt-2">
                Global prompt for AI agents
              </div>
              <div className="font-jetbrains text-label uppercase tracking-normal text-tertiary mt-2">
                GLOBAL PROMPT
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
